import BasemodelValidationClient from "@/services/baseClient";
import router from '@/router';

export class ModelValidationClient extends BasemodelValidationClient {
  createInstance() {
    super.createInstance();

    this.baseURL =process.env.NODE_ENV === 'production' ? '/api/v1' : process.env.VUE_APP_MODEL_VALIDATION_API_URI
    this.instance.defaults.baseURL = this.baseURL;

    this.instance.interceptors.response.use(
      response => response,
      error => {
          
        if (error.response && error.response.status === 401) {          
          // Clear localStorage
          if (typeof error?.response?.data === 'string' && error?.response?.data?.includes('incorrect otp code')) {
            return
          }
          localStorage.clear();
          router.go({ name: 'login'})
        }
        return Promise.reject(error);
      }
    );
  }
  

  // POST

  // login
  async login({username, password}) {
    return this.instance.post(`/login`, {username, password});
  }

  async OptLogin({ username, otp, tenantId }) {
    return this.instance.post(`/login/opt`, { username, otp, tenantId }); 
  }
  // new-tenant
  async addTenant(tenantData) {
    return this.instance.post('/tenant', tenantData)
  }

  async addUser(user) {
    return this.instance.post('/users', user);
  }

  async updateTenant(tenantData) {
    return this.instance.put(`/tenant/${tenantData.tenantId}`, tenantData)
  }

  async updateAssessmentRequest(tenantId, requestAssessment) {
    return this.instance.put(`/${tenantId}/request-assessment/${requestAssessment}`)
  }


  async setTenantRails(tenantId, rails) {
    return this.instance.post(`/tenant/${tenantId}/rails`, rails)
  }

  async getTenants(tenantId = '') {
    let requestUrl = '/tenants'
    if (tenantId) requestUrl += `?tenantId=${tenantId}`
    return await this.instance.get(requestUrl)
  }

  async getUsers(tenantId) {
    if (tenantId) {
      return await this.instance.get(`/users/${tenantId}`)
    }
    return await this.instance.get('/users')
  }

  async updateUser(update) {
    const { username } = update;    
    return this.instance.put(`/users/${username}`, update);
  }

  async changePassword(username, password, newPassword) {
    return this.instance.put(`/users/password`, {
      username,
      password,
      newPassword,
    });
  }

  async deleteUser({ username }) {
    return this.instance.delete(`/users/${username}`);
  }

  // new-configuration
  // Generate a new document with the data sent (names, cases)
  async postConfiguration({
    totalNumberOfNames, 
    numberOfNames, 
    cases, 
    tenantId, 
    userId,
    profileType
  }) {
    if (typeof numberOfNames === 'string') {
      numberOfNames = parseInt(numberOfNames)
    }

    if (typeof totalNumberOfNames === 'string') {
      totalNumberOfNames = parseInt(totalNumberOfNames)
    }
    return this.instance.post(`/new-sample`, { 
      totalNumberOfNames, 
      numberOfNames, 
      cases, 
      tenantId, 
      userId,
      profileType
    });
  }

  async newTestCase(testObject) {
    return await this.instance.post('/new-test', testObject)
  }

  // upload-bank-results-file
  async uploadAndCompare({ 
    configsId, 
    testId, 
    dateForCompare,
    notesForCompare,
    sanctionsList,
    selectedIndexId,    
    file, 
    description, 
    tenantId = localStorage.getItem('tenantId') 
  }) {
    const formData = new FormData();
    const uploadedBy = localStorage.getItem('user-name');
    
    formData.append('file', file);
    formData.append('description', description);
    formData.append('type', 'model-validation');
    formData.append('configsId', configsId);
    formData.append('testId', testId);
    formData.append('dateForRun', new Date(dateForCompare).toLocaleDateString('en-CA'));
    formData.append('notesForCompare', notesForCompare);
    formData.append('sanctionsList', sanctionsList);
    formData.append('selectedIndexId', selectedIndexId);
    formData.append('uploadedBy', uploadedBy);
    formData.append('tenantId', tenantId);

    return this.instance.post('/upload-bank-results-file', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  async runCompareWithExistingFile(configsId, fileData) {
    return this.instance.post(`/compare-previousFile/${configsId}`, {...fileData});
  }

  async questionnaire504(questionnaireBody) {
    return this.instance.post('questionnaire/504', questionnaireBody)
  }

  async updateQuestionnaire(questionnaireType, questionnaireBody) {
    return this.instance.post('questionnaire/504/update', {
      questionnaireType, 
      stringQuestionnaire: typeof questionnaireBody === 'string' ? questionnaireBody : JSON.stringify(questionnaireBody),
    })
  }
  
  // uploadSampleNames
  async uploadSampleNames(file, sheetName) {
    const formData = new FormData();
    const uploadedBy = localStorage.getItem('user-name');
    
    formData.append('file', file);
    formData.append('sheetName', sheetName);

    formData.append('uploadedBy', uploadedBy);

    return this.instance.post('upload-sample-names', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  // PUT
  async updateStatus(_id, status) {
    return this.instance.put(`/update-status/${_id}?status=${status}`);
  }

  async passwordsReset(tenantId) {
    return this.instance.put(`/${tenantId}/request-password-reset`);
  }
  
  // GET

  // test
  async test() {
    return this.instance.get('/',);
  }

  // summary report
  // 
  async getSummaryReport() {
    return this.instance.get('/sanctions-list',);
  }

  // cases-list
  // Returns all the cases we can compare by.
  async getCasesList() {
    return this.instance.get(`/cases-list`);
  }
  
  // random-names
  // Returns a list of random names.
  // async getRandomNames(count) {
  //   return this.instance.get(`${this.modelValidationRoute}/random-names/${count}`);
  // }
  
  // names/:runId
  // Returns a list of names by run _id
  // async getNamesByRunId(_id) {
  //   return this.instance.get(`/names/${_id}`);
  // }
  
  // previous-configurations/:tid
  // Returns a list of previous runs by tenantId
  async getPreviousConfigurationsByTenantId({tenantId, page, itemsPerPage, sortBy, sortOrder}) {
    let requestString = `/previous-configurations/${tenantId}?page=${page}&itemsPerPage=${itemsPerPage}`
    if (sortBy) requestString += `&sortBy=${sortBy}&sortOrder=${sortOrder}`
    return this.instance.get(requestString);
  }

  async getTestCasesByTenantId({tenantId, page, itemsPerPage, sortBy, sortOrder, financialInstitution}) {
    let requestString = `/test-cases/${tenantId}?page=${page}&itemsPerPage=${itemsPerPage}`
    if (sortBy) requestString += `&sortBy=${sortBy}&sortOrder=${sortOrder}`
    if (financialInstitution) requestString += `&financialInstitution=${financialInstitution}`
    return this.instance.get(requestString);
  }

  // /compare-logs/:tid
  async getCompareLogsByTenantId({tenantId, page, itemsPerPage, sortBy, sortOrder,financialInstitution}) {
    let requestString = `/compare-logs/${tenantId}?page=${page}&itemsPerPage=${itemsPerPage}`
    if (sortBy) requestString += `&sortBy=${sortBy}&sortOrder=${sortOrder}`
    if (financialInstitution) requestString += `&financialInstitution=${financialInstitution}`

    return this.instance.get(requestString);
  }

  // :runId/details
  // Returns more in depth data of a run by it's Id.
  async getRunDetails( _id ) {
    return this.instance.get(`/${_id}/details`);
  }
  
  // :runId/report
  // Get the information for the report to download by runId.
  // async getReportData( _id ) {
  //   return this.instance.get(`${this.modelValidationRoute}/${_id}/report`);
  // }
  
  // fincom-results/:runId
  // Returns the data from the fincom run by runId.
  async downloadLatestResults(fileId) {
    return this.instance.get(`/fincom-results/${fileId}`);
  }

  async getComparelogById(_id) {
    return this.instance.get(`/compare-names-by-id/${_id}`);
  }

  async getLastQuestionnaire(questionnaireType) {
    return this.instance.get(`questionnaire/504/${questionnaireType}`)
  }

  async getUserLastQuestionnaire(questionnaireType, userId, status = 'in_progress') {
    return this.instance.get(`questionnaire/504/${questionnaireType}/${userId}?status=${status}`)
  }

  // /assessment/504/:tenantId
  async getLastAssessmentByTenantId(tenantId) {
    return this.instance.get(`assessment/504/${tenantId}`)
  }

  // async getQuestionnaireByTenantId({tenantId, type, page, itemsPerPage, sortBy, sortOrder}) {
  async getQuestionnaireByTenantId({tenantId, page, itemsPerPage, sortBy, sortOrder, status}) {  
    // let requestString = `/questionnaires/${tenantId}/${type}?page=${page}&itemsPerPage=${itemsPerPage}`
    let requestString = `/questionnaires/${tenantId}?page=${page}&itemsPerPage=${itemsPerPage}&status=${status}`
    if (sortBy) requestString += `&sortBy=${sortBy}&sortOrder=${sortOrder}`
    return this.instance.get(requestString);
  }

      // /tenants/:tid/financialInstitution/questionnaires
  async GetFiQuestionnairesList(tenantId, fi) {
    return this.instance.get(`/tenants/${tenantId}/financialInstitution/questionnaires?fi=${fi}`)
  }

  async getQuestionnaireResult(documentId) {
    return this.instance.get(`/questionnaire/result/${documentId}`);
  }

  // DELETE
  // logout
  logout = async (username) => {
    const userToken = localStorage.getItem('user-token');
    if (userToken) {
      const headers = {};
      headers['x-access-token'] = userToken;
      
      return await this.instance.post('/logout', { username }, { headers })
    }
  }
  
  // cancelQuestionnaireById
  async cancelQuestionnaireById(questionnaireId) {
    return this.instance.delete(`questionnaire/504/${questionnaireId}`)
  }
}

export default new ModelValidationClient();
